import React from "react";
// style
import './Backdrop.scss';

const Backdrop = (props) => {
  return <div className="backdrop" onClick={() => props.setSideDrawerOpen(false)} ></div>;
};

export default Backdrop;
